<div class="dash-main-content">

  <!-- Titre & actions — toujours visibles -->
  <div class="dash-top">
    <div style="display: flex; margin-bottom: 3%;">
      <h2 class="dash-title">Gestion des utilisateurs</h2>
            
      <!-- Bouton "Créer un utilisateur" — visible uniquement si permission -->
      <div class="dash-action-right">
        <!-- Bouton Télécharger le modèle -->

        <button type="button" class="button button-icon neutral" (click)="downloadTemplate()">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 17V19C4 20.1 4.9 21 6 21H18C19.1 21 20 20.1 20 19V17" stroke="currentColor" stroke-width="1.5"
              stroke-linecap="round" />
            <path d="M12 3V15M8 11L12 15L16 11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
          <span>Télécharger fiche création</span>
        </button>

        <!-- Bouton Créer un utilisateur existant -->
        <a *hasPermission="'users.create'" [routerLink]="['/dashboard/users/add']" class="button button-icon primary">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
            viewBox="0 0 24 24"><!-- Icon from Material Symbols Light by Google - https://github.com/google/material-design-icons/blob/master/LICENSE -->
            <path fill="currentColor" d="M11.5 12.5H6v-1h5.5V6h1v5.5H18v1h-5.5V18h-1z" />
          </svg>
          <span>Créer un utilisateur</span>
        </a>
      </div>
    </div>

    <div class="dash-action">
      <div class="dash-action-left" [class.controls-disabled]="loading">
        <div class="field-search-btn">
          <input [formControl]="searchControl" type="text" placeholder="Rechercher (nom, email, IES, établissement)"
            class="search-icon" [attr.tabindex]="loading ? -1 : null">
          @if (!searchControl.value) {
          <button [disabled]="loading">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M20.0003 11.9998L4.00024 11.9998" stroke="#1E1F24" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
              <path d="M15.0003 17C15.0003 17 20.0002 13.3176 20.0002 12C20.0003 10.6824 15.0002 7 15.0002 7"
                stroke="#1E1F24" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </button>
          }
        </div>

        <div class="select-wrapper">
          <select class="filter-select" [value]="selectedFilter" (change)="onFilterSelect($event)" [disabled]="loading">
            <option value="all">Tous les utilisateurs</option>
            <option value="verified">Vérifiés</option>
            <option value="unverified">Non vérifiés</option>
            <option value="enabled">Activés</option>
            <option value="disabled">Désactivés</option>
          </select>
        </div>
      </div>
    </div>
  </div>

  <!-- Statistiques compactes -->
  @if (!statsLoading) {
  <div class="stats-container">
    <div class="stats-inline">
      <span class="stat-item">
        <strong>Total :</strong> {{ stats?.total ?? 0 }}
      </span>
      <span class="stat-item stat-verified">
        <strong>Vérifiés :</strong> {{ stats?.verified ?? 0 }}
      </span>
      <span class="stat-item stat-unverified">
        <strong>Non vérifiés :</strong> {{ stats?.unverified ?? 0 }}
      </span>
      <span class="stat-item stat-disabled">
        <strong>Désactivés :</strong> {{ stats?.disabled ?? 0 }}
      </span>
    </div>
  </div>
  } @else {
  <div class="stats-inline">
    <span class="stat-item skeleton">Total : <span class="skeleton-text"
        style="width:30px;display:inline-block;"></span></span>
    <span class="stat-item skeleton">Vérifiés : <span class="skeleton-text"
        style="width:30px;display:inline-block;"></span></span>
    <span class="stat-item skeleton">Non vérifiés : <span class="skeleton-text"
        style="width:30px;display:inline-block;"></span></span>
    <span class="stat-item skeleton">Désactivés : <span class="skeleton-text"
        style="width:30px;display:inline-block;"></span></span>
  </div>
  }

  <!-- Table — le header est toujours affiché -->
  <table class="table">
    <thead>
      <tr>
        <th>Nom utilisateur</th>
        <th>E-mail</th>
        <th>Vérification</th>
        <th>Statut</th>
        <th>Actions</th>
      </tr>
      <!-- Barre de progression sous le header pendant le chargement -->
      @if (loading) {
      <tr class="table-loading-row">
        <td colspan="5">
          <div class="table-progress-bar">
            <div class="table-progress-bar-inner"></div>
          </div>
        </td>
      </tr>
      }
    </thead>
    <tbody>
      <!-- Skeleton rows pendant le chargement -->
      @if (loading) {
      @for (i of [1,2,3,4,5]; track i) {
      <tr class="skeleton-row">
        <td><span class="skeleton skeleton-text"></span></td>
        <td><span class="skeleton skeleton-text skeleton-text--wide"></span></td>
        <td><span class="skeleton skeleton-badge"></span></td>
        <td><span class="skeleton skeleton-toggle"></span></td>
        <td><span class="skeleton skeleton-actions"></span></td>
      </tr>
      }
      }

      <!-- Données chargées -->
      @if (!loading && users.length > 0) {
      @for (user of users; track user) {
      <tr>
        <td>{{ user.firstName }} {{ user.lastName }}</td>
        <td>{{ user.email || 'Pas de mail' }}</td>
        <td>
          <div [class]="user.emailVerified ? 'badge success' : 'badge danger'">
            {{ user.emailVerified ? 'Vérifié' : 'Non Vérifié' }}
          </div>
        </td>
        <!-- Toggle statut — masqué si pas la permission -->
        <td>
          @if (perm.can('users.toggle_status')) {
          <form>
            <label class="switch">
              <input type="checkbox" [checked]="user.enabled" (change)="openStatusDialog(user, $event)">
              <span class="slider round"></span>
            </label>
            <span class="status-text">{{ user.enabled ? 'Activé' : 'Désactivé' }}</span>
          </form>
          } @else {
          <span class="status-text">{{ user.enabled ? 'Activé' : 'Désactivé' }}</span>
          }
        </td>
        <td>
          <ul class="table-actions-icons">
            <!-- Bouton édition -->
            <li *hasPermission="'users.edit'">
              <a [routerLink]="['/dashboard/users', user.id, 'edit']">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M14.0737 3.88545C14.8189 3.07808 15.1915 2.6744 15.5874 2.43893C16.5427 1.87076 17.7191 1.85309 18.6904 2.39232C19.0929 2.6158 19.4769 3.00812 20.245 3.79276C21.0131 4.5774 21.3972 4.96972 21.6159 5.38093C22.1438 6.37312 22.1265 7.57479 21.5703 8.5507C21.3398 8.95516 20.9446 9.33578 20.1543 10.097L10.7506 19.1543C9.25288 20.5969 8.504 21.3182 7.56806 21.6837C6.63212 22.0493 5.6032 22.0224 3.54536 21.9686L3.26538 21.9613C2.63891 21.9449 2.32567 21.9367 2.14359 21.73C1.9615 21.5234 1.98636 21.2043 2.03608 20.5662L2.06308 20.2197C2.20301 18.4235 2.27297 17.5255 2.62371 16.7182C2.97444 15.9109 3.57944 15.2555 4.78943 13.9445L14.0737 3.88545Z"
                    stroke="#5C6465" stroke-width="1.5" stroke-linejoin="round" />
                  <path d="M13 4L20 11" stroke="#5C6465" stroke-width="1.5" stroke-linejoin="round" />
                  <path d="M14 22L22 22" stroke="#5C6465" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </a>
            </li>
            <!-- Bouton détail -->
            <li>
              <button class="open-modal" [routerLink]="['/dashboard/users', user.id, 'view']">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="12" cy="12" r="10" stroke="#5C6465" stroke-width="1.5" />
                  <path d="M11.992 15H12.001" stroke="#5C6465" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M12 12L12 8" stroke="#5C6465" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </button>
            </li>
            <!-- Bouton gestion des rôles — SUPER_ADMIN uniquement -->
            <li *hasPermission="'users.manage_roles'">
              <button class="open-modal" (click)="openRolesDialog(user)" title="Gérer les rôles">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M3.78879 9.03708C3.0814 9.42 1.22668 10.2019 2.35633 11.1803C2.90815 11.6582 3.52275 12 4.29543 12H8.70457C9.47725 12 10.0918 11.6582 10.6437 11.1803C11.7733 10.2019 9.9186 9.42 9.21121 9.03708C7.55241 8.13915 5.44759 8.13915 3.78879 9.03708Z"
                    stroke="#5C6465" stroke-width="1.5" />
                  <path
                    d="M8.75 4.27273C8.75 5.52792 7.74264 6.54545 6.5 6.54545C5.25736 6.54545 4.25 5.52792 4.25 4.27273C4.25 3.01753 5.25736 2 6.5 2C7.74264 2 8.75 3.01753 8.75 4.27273Z"
                    stroke="#5C6465" stroke-width="1.5" />
                  <path d="M4 15C4 18.3171 6.68286 21 10 21L9.14286 19.2857" stroke="#5C6465" stroke-width="1.5"
                    stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M20 9C20 5.68286 17.3171 3 14 3L14.8571 4.71429" stroke="#5C6465" stroke-width="1.5"
                    stroke-linecap="round" stroke-linejoin="round" />
                  <path
                    d="M14.7888 19.0371C14.0814 19.42 12.2267 20.2019 13.3563 21.1803C13.9082 21.6582 14.5227 22 15.2954 22H19.7046C20.4773 22 21.0918 21.6582 21.6437 21.1803C22.7733 20.2019 20.9186 19.42 20.2112 19.0371C18.5524 18.1392 16.4476 18.1392 14.7888 19.0371Z"
                    stroke="#5C6465" stroke-width="1.5" />
                  <path
                    d="M19.75 14.2727C19.75 15.5279 18.7426 16.5455 17.5 16.5455C16.2574 16.5455 15.25 15.5279 15.25 14.2727C15.25 13.0175 16.2574 12 17.5 12C18.7426 12 19.75 13.0175 19.75 14.2727Z"
                    stroke="#5C6465" stroke-width="1.5" />
                </svg>
              </button>
            </li>
            <!-- Menu déroulant -->
            @if (perm.can('users.manage_groups') || perm.can('users.reset_password') ||
            perm.can('users.send_verification')) {
            <li>
              <button class="table-actions-dropdown button-no-style" (click)="toggleDropdown(user.id)"
                [class.active]="activeDropdownId === user.id">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11.992 12H12.001" stroke="#23A93E" stroke-width="2.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M11.9842 18H11.9932" stroke="#23A93E" stroke-width="2.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M11.9998 6H12.0088" stroke="#23A93E" stroke-width="2.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </button>
              <ul class="table-actions-item" [class.hide]="activeDropdownId !== user.id">
                <!-- <li *hasPermission="'users.manage_groups'">
                                                          <a (click)="openGroupsDialog(user)">Gestion des groupes</a>
                                                        </li> -->
                <li *hasPermission="'users.reset_password'">
                  <a (click)="onResetPassword(user)" [class.disabled]="processingUserIds.has(user.id)">
                    @if (processingUserIds.has(user.id)) {
                    <span class="spinner-border spinner-border-sm mr-1"></span>
                    }
                    Réinitialiser mot de passe
                  </a>
                </li>
                <li *hasPermission="'users.send_verification'">
                  <a (click)="sendEmailVerification(user)" [class.disabled]="processingUserIds.has(user.id)">
                    @if (processingUserIds.has(user.id)) {
                    <span class="spinner-border spinner-border-sm mr-1"></span>
                    }
                    Envoyer mail de vérification
                  </a>
                </li>
              </ul>
            </li>
            }
          </ul>
        </td>
      </tr>
      }
      }

      <!-- État vide — données chargées mais aucun résultat -->
      @if (!loading && users.length === 0) {
      <tr>
        <td colspan="5" class="table-empty-state">
          <div class="table-empty-state-inner">
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M14.5 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V7.5L14.5 2Z"
                stroke="#C4C8C8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M14 2V8H20" stroke="#C4C8C8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M9 15H15" stroke="#C4C8C8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M9 11H15" stroke="#C4C8C8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>

            <p class="table-empty-state-title">
              {{ (searchControl.value?.trim() || selectedFilter !== 'all')
              ? 'Aucun résultat pour cette recherche'
              : 'Aucun utilisateur à afficher' }}
            </p>

            <p class="table-empty-state-subtitle">
              {{ (searchControl.value?.trim() || selectedFilter !== 'all')
              ? 'Essayez de modifier vos critères de recherche ou de filtre.'
              : 'Les utilisateurs apparaîtront ici une fois ajoutés.' }}
            </p>
          </div>
        </td>
      </tr>
      }
    </tbody>
  </table>

  <!-- Pagination — désactivée pendant le chargement -->
  @if (totalPages > 1) {
  <div class="paginate" [class.controls-disabled]="loading">
    <a (click)="!loading && goToPreviousPage()" [class.disabled]="currentPage === 0 || loading"
      class="paginate-arrow left">
      <svg width="6" height="9" viewBox="0 0 6 9" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path [attr.stroke]="(currentPage === 0 || loading) ? '#CCCCCC' : 'black'" d="M4.27 7.81L0.75 4.28L4.27 0.75"
          stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </a>
    <ul class="paginate-item">
      @for (page of getDisplayPages(); track page) {
      <li [class.is-active]="page === currentPage + 1" [class.dots]="page === '...'">
        @if (page !== '...') {
        <a (click)="!loading && goToPage(+page - 1)">{{ page }}</a>
        }
        @if (page === '...') {
        <span>...</span>
        }
      </li>
      }
    </ul>
    <a (click)="!loading && goToNextPage()" [class.disabled]="currentPage === totalPages - 1 || loading"
      class="paginate-arrow right">
      <svg width="6" height="9" viewBox="0 0 6 9" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path [attr.stroke]="(currentPage === totalPages - 1 || loading) ? '#CCCCCC' : '#5E5E5E'"
          d="M0.75 7.81L4.27 4.28L0.75 0.75" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </a>
  </div>
  }
</div>